import i18n from 'i18next';

import { CURRENCY_FORMAT } from '@common/constants';
import formatUOM from '@common/helpers/formatUOM';

export const formatPriceUnitOrFree = (
    price?: number | null,
    unit?: string | null,
    freeValue?: string | null
): string => {
    if (price && unit) {
        return `${CURRENCY_FORMAT.format(Number(price))} ${formatUOM(unit)}`;
    }
    if (price) {
        return CURRENCY_FORMAT.format(Number(price));
    }
    return freeValue ?? i18n.t('COMMON.FREE_PRICE'); // return the given free or the standard
};
